import { render, staticRenderFns } from "./ChangeOrderComponent.vue?vue&type=template&id=f9212f0e&"
import script from "./ChangeOrderComponent.vue?vue&type=script&lang=js&"
export * from "./ChangeOrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrderComponent.vue?vue&type=style&index=0&id=f9212f0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports